import { useState, useLayoutEffect } from 'react';
const getElementFromHoverTarget = (hoverTarget) => {
    if (typeof hoverTarget === 'function') {
        return hoverTarget();
    }
    else if (hoverTarget instanceof Node) {
        return hoverTarget;
    }
    else if (hoverTarget && hoverTarget.hasOwnProperty('current')) {
        return hoverTarget.current;
    }
    else {
        console.error('HoverVideoPlayer was unable to get a usable hover target element. Please check your usage of the `hoverTarget` prop.');
    }
};
export default function useHoverTargetElement(hoverTarget) {
    const [hoverTargetElement, setHoverTargetElement] = useState(() => getElementFromHoverTarget(hoverTarget));
    useLayoutEffect(() => {
        setHoverTargetElement(getElementFromHoverTarget(hoverTarget));
    }, [hoverTarget]);
    return hoverTargetElement;
}
